import { render, staticRenderFns } from "./RFQ2Form.vue?vue&type=template&id=df1a28a8&"
import script from "./RFQ2Form.vue?vue&type=script&lang=js&"
export * from "./RFQ2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports